// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import ReactGA from "react-ga4";

var initialConfigCommonJS = require("../js/initialConfigCommon.js");
var generalCommonJS = require("../js/generalCommon.js");

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postEmail = endpointHelias+'/Helias/V0/Messaging/postEmail'

const textoPlaceholder = "Si puede esperar, mejor escríbenos aquí tu duda o problema de forma detallada y si es posible adjuntanos alguna captura de pantalla que nos ayude a entender mejor qué te sucede. Puedes añadir hasta 5 adjuntos, si fueran más archivos, por favor, comprímelos en un único fichero .ZIP."

var adjunto1Base64 = ""
var adjunto2Base64 = ""
var adjunto3Base64 = ""
var adjunto4Base64 = ""
var adjunto5Base64 = ""

// CONFIGURACIÓN
const Support = () => {

  useEffect(() => {           
    generalCommonJS.autocierrePrivacidadGoogle()
    console.log("Página de soporte técnico cargada correctamente.")
  }, []);

  function generarAdjuntoBase64(idAdjunto) {
    
    var reader = new FileReader();
    var f = ""

    if(idAdjunto === "adjunto1"){ f = document.getElementById("adjunto1").files; }
    else if(idAdjunto === "adjunto2"){ f = document.getElementById("adjunto2").files; }
    else if(idAdjunto === "adjunto3"){ f = document.getElementById("adjunto3").files; }
    else if(idAdjunto === "adjunto4"){ f = document.getElementById("adjunto4").files; }
    else if(idAdjunto === "adjunto5"){ f = document.getElementById("adjunto5").files; }

    reader.onloadend = function () {    

        if(idAdjunto === "adjunto1"){ adjunto1Base64 = reader.result }
        else if(idAdjunto === "adjunto2"){ adjunto2Base64 = reader.result }
        else if(idAdjunto === "adjunto3"){ adjunto3Base64 = reader.result }
        else if(idAdjunto === "adjunto4"){ adjunto4Base64 = reader.result }
        else if(idAdjunto === "adjunto5"){ adjunto5Base64 = reader.result }
        
    }
    reader.readAsDataURL(f[0]);

}

  function enviarEmail(){

    document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replace(" hidden", "")

    var cuerpoCompletoMensaje = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")+"·"+generalCommonJS.obtenerNombreUsuario()+"·"+generalCommonJS.obtenerApellidosUsuario()+"·"+generalCommonJS.obtenerEmailUsuario()+"·"+generalCommonJS.obtenerTelefonoUsuario()+"·"+localStorage.getItem("installationId")+"·"+document.getElementById("message").value

    var listadoAdjuntos = []

    if(adjunto1Base64 !== ""){ listadoAdjuntos.push({"adjunto1" : adjunto1Base64 }) }
    if(adjunto2Base64 !== ""){ listadoAdjuntos.push({"adjunto2" : adjunto2Base64 }) }
    if(adjunto3Base64 !== ""){ listadoAdjuntos.push({"adjunto3" : adjunto3Base64 }) }
    if(adjunto4Base64 !== ""){ listadoAdjuntos.push({"adjunto4" : adjunto4Base64 }) }
    if(adjunto5Base64 !== ""){ listadoAdjuntos.push({"adjunto5" : adjunto5Base64 }) }

    //Petición de datos para el paso actual
    var jsonPeticion = {            
      "mensaje": generalCommonJS.obtenerEmailUsuario()+"###"+cuerpoCompletoMensaje,
      "adjuntos": listadoAdjuntos,
      "origen": "SOPORTE"
    }

    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", postEmail, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");      
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
  
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("Se ha producido un error al enviar el mensaje, vuelve a intentarlo en unos minutos.","negative")
          }
          else{          
            //Si recibo datos ya configurados lo cargo  

            if(typeof jsonRespuesta.body !== 'undefined'){             
              initialConfigCommonJS.mostrarMensajeInformativo("Mensaje enviado correctamente, en breve nos pondremos en contacto contigo.","positive")                            
              
              document.getElementById("message").value = ""
              document.getElementById("message").placeholder = textoPlaceholder
              
              document.getElementById("adjunto1").className = " hidden"
              document.getElementById("adjunto1").value = ""
              adjunto1Base64 = ""

              document.getElementById("adjunto2").className = " hidden"
              document.getElementById("adjunto2").value = ""
              adjunto2Base64 = ""

              document.getElementById("adjunto3").className = " hidden"
              document.getElementById("adjunto3").value = ""
              adjunto3Base64 = ""

              document.getElementById("adjunto4").className = " hidden"
              document.getElementById("adjunto4").value = ""
              adjunto4Base64 = ""

              document.getElementById("adjunto5").className = " hidden"
              document.getElementById("adjunto5").value = ""
              adjunto5Base64 = ""
              
              document.getElementById("fieldsetAdjuntos").className = " hidden"
              document.getElementById("botonMostrarAdjunto").className = document.getElementById("botonMostrarAdjunto").className.replaceAll(" hidden")

            }  

            generalCommonJS.registrarEventoAnalitica(ReactGA, 'SOPORTE', 'SOPORTE - Solicitud enviada', generalCommonJS.obtenerEmailUsuario()+"###"+cuerpoCompletoMensaje, "")

            //Si no hay datos configurados entonces no hago nada  
            console.log("Solicitud de soporte enviada correctamente.")
          }

          document.getElementById("loaderGeneralAplicacion").className += " hidden"

        }
  
        if (this.readyState === 4 && this.status !== 200) {      
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
        }
      }
      xhttp.send(data);    

  }

  function mostrarSiguienteAdjunto(){

    if(document.getElementById("fieldsetAdjuntos").className.includes(" hidden")){
      document.getElementById("fieldsetAdjuntos").className = document.getElementById("fieldsetAdjuntos").className.replaceAll(" hidden", "")
    }

    if(document.getElementById("adjunto1").className.includes(" hidden")){ document.getElementById("adjunto1").className = document.getElementById("adjunto1").className.replaceAll(" hidden", "") }
    else if(document.getElementById("adjunto2").className.includes(" hidden")){ document.getElementById("adjunto2").className = document.getElementById("adjunto2").className.replaceAll(" hidden", "") }
    else if(document.getElementById("adjunto3").className.includes(" hidden")){ document.getElementById("adjunto3").className = document.getElementById("adjunto3").className.replaceAll(" hidden", "") }
    else if(document.getElementById("adjunto4").className.includes(" hidden")){ document.getElementById("adjunto4").className = document.getElementById("adjunto4").className.replaceAll(" hidden", "") }
    else if(document.getElementById("adjunto5").className.includes(" hidden")){ 
      document.getElementById("adjunto5").className = document.getElementById("adjunto5").className.replaceAll(" hidden", "") 
      document.getElementById("botonMostrarAdjunto").className += " hidden"
    }

  }

  return (
     
      <section id="sectionSupport" className="wrapper">
        
        <div className="content-wrapper">            

          <div className="description comment bubble">        
            <h1 className="headline-03 no-helias horizontal"><span className="fill">Ayuda y soporte</span></h1>   
          </div>    

            <fieldset className="text">

              <label htmlFor="name" style={{paddingTop: "5px"}}>¿En qué te podemos ayudar?</label>       

              <a href="tel://604909157" className="selector icon-wrapper">              
                <figure className="avatar size-m cyan"><span className="material-icon">call</span></figure>
                <div className="content">
                  <h1 className="brand-name">¿Es urgente? Llámanos.</h1>
                  <p className="size-s">Lunes a Viernes de 9:00 - 14:00 y de 16:30 - 19:30</p>
                </div>
              </a> 

              <textarea id="message" name="message" rows="10" placeholder={textoPlaceholder} required=""></textarea>
            </fieldset>

            <fieldset id="fieldsetAdjuntos" className=" hidden">
              <input type="file" className=" hidden" id="adjunto1" name="adjunto1" accept=".pdf,.jpg,.png,.zip" onChange={() => generarAdjuntoBase64("adjunto1")}/>
              <input type="file" className=" hidden" id="adjunto2" name="adjunto2" accept=".pdf,.jpg,.png,.zip" onChange={() => generarAdjuntoBase64("adjunto2")}/>
              <input type="file" className=" hidden" id="adjunto3" name="adjunto3" accept=".pdf,.jpg,.png,.zip" onChange={() => generarAdjuntoBase64("adjunto3")}/>
              <input type="file" className=" hidden" id="adjunto4" name="adjunto4" accept=".pdf,.jpg,.png,.zip" onChange={() => generarAdjuntoBase64("adjunto4")}/>
              <input type="file" className=" hidden" id="adjunto5" name="adjunto5" accept=".pdf,.jpg,.png,.zip" onChange={() => generarAdjuntoBase64("adjunto5")}/>
            </fieldset>

            <button id="botonMostrarAdjunto" className="link" onClick={() => mostrarSiguienteAdjunto()}><span className="material-icon">add</span>Añadir adjunto</button>

            <ul className="actions">
              <li><button id="botonEnviar" className="button primary" onClick={() => enviarEmail()}>Enviar</button></li>            
            </ul>

        </div>

      </section>      
    
  )
}

export default Support